"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadMetricsCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class LoadMetricsCommand extends AbstractCommand_1.AbstractCommand {
    constructor(api, appId) {
        super(api);
        this.pageSize = 10;
        this.pageNumber = 0;
        this.withPageSize = (pageSize) => {
            this.pageSize = pageSize;
            return this;
        };
        this.withPage = (pageNumber) => {
            this.pageNumber = pageNumber;
            return this;
        };
        this.appId = appId;
    }
    async exec() {
        const result = await this.api.get(`/metrics/messages/application/${this.appId}`, {
            params: {
                page: this.pageNumber,
                per_page: this.pageSize,
                sort: 'desc',
                search: '',
            },
        });
        const list = result.data;
        return {
            total: result.headers['total'],
            list: list,
        };
    }
}
exports.LoadMetricsCommand = LoadMetricsCommand;
//# sourceMappingURL=LoadMetricsCommand.js.map